import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AuthenticationService, AuthorizationService, UiPermissionAttributes } from '@ravago/ravapps-angular-auth-front';
import { Observable } from 'rxjs';

import { AppService } from './core/services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    public appService: AppService,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService
  ) {}

  authorizedApplications$: Observable<UiPermissionAttributes[]>;

  appIconMap: AppIcon[] = [
    {
      appId: 'blue-order-search',
      className: 'my-apps__app-icon--blue-order-search'
    },
    {
      appId: 'blue-jobbing',
      className: 'my-apps__app-icon--blue-jobbing'
    },
    {
      appId: 'ohm',
      className: 'my-apps__app-icon--ohm'
    },
    {
      appId: 'blue-company-search',
      className: 'my-apps__app-icon--blue-company-search'
    },
    {
      appId: 'blue-credit-workspace',
      className: 'my-apps__app-icon--blue-credit-workspace'
    },
    {
      appId: 'blue-sales-order-entry',
      className: 'my-apps__app-icon--blue-sales-order-entry'
    },
    {
      appId: 'mrp',
      className: 'my-apps__app-icon--mrp'
    },
    {
      appId: 'dayforce',
      className: 'my-apps__app-icon--dayforce'
    },
    {
      appId: 'agreement',
      className: 'my-apps__app-icon--agreement'
    },
    {
      appId: 'BlueICR',
      className: 'my-apps__app-icon--BlueICR'
    }, {
      appId: 'DocumentWorkspace',
      className: 'my-apps__app-icon--DocumentWorkspace'
    },
    {
      appId: 'CertificateManagement',
      className: 'my-apps__app-icon--CertificateManagement'
    },
    {
      appId: 'pc_workspace',
      className: 'my-apps__app-icon--pc-workspace'
    },
    {
      appId: 'SARA',
      className: 'my-apps__app-icon--sara'
    },
    {
      appId: 'WMS2MOBILE',
      className: 'my-apps__app-icon--wms-mobile'
    },
    {
      appId: 'WMS2OFFICE',
      className: 'my-apps__app-icon--wms-office'
    },
    {
      appId: 'quality-control',
      className: 'my-apps__app-icon--quality-control'
    },
    {
      appId: 'business-channel-inventory',
      className: 'my-apps__app-icon--business-channel-inventory'
    },
  ];

  ngOnInit(): void {
    this.authorizedApplications$ = this.authorizationService.getAuthorizedApplications();
  }

  get formattedDate() {
    return moment().format('dddd, MMMM Do');
  }

  get humanizedGreeting(): string {
    const currentTime = moment();

    const splitAfternoon = 12;
    const splitEvening = 17;
    const currentHour = parseFloat(currentTime.format('HH'));

    if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
      return 'Good afternoon';
    } else if (currentHour >= splitEvening) {
      return 'Good evening';
    }

    return 'Good morning';
  }

  get userFullName(): string {
    return (!this.authenticationService.user) ? '' :
      `${this.authenticationService.user.firstName} ${this.authenticationService.user.lastName}`;
  }

  get userFirstName(): string {
    return (!this.authenticationService.user) ? '' : `${this.authenticationService.user.firstName}`;
  }

  logout(): void {
    this.authenticationService.logout();
  }

  remapAppIcon(appId: string): string {
    const foundAppIcon = this.appIconMap.find(appIcon => appId.startsWith(appIcon.appId));

    return foundAppIcon === undefined ? '' : foundAppIcon.className;
  }
}

export interface AppIcon {
  appId: string;
  className: string;
}
